import { Tabs } from 'antd';
import SelectResult from './SelectResult';
import { useState } from 'react';
import ListSelect from './ListSelect';
import { uniq } from 'lodash-es';
import BatchSelect from './BatchSelect';
import styled from '@emotion/styled';
import { useTranslate } from '@tolgee/react';

function SelectContent({
  filter,
  value,
  onChange,
}: {
  filter: Omit<ReviewAnalysis.OverviewFilter, 'spuIds'>;
  value: string[];
  onChange: (value: string[]) => void;
}) {
  const { t } = useTranslate();

  const [itemMap, setItemMap] = useState<Partial<Record<string, ReviewAnalysis.Item>>>({});

  const [activeKey, setActiveKey] = useState('list');

  const onSelect = (items: ReviewAnalysis.Item[]) => {
    setItemMap((pre) => {
      return items.reduce(
        (res, cur) => {
          res[cur.spuKey] = cur;
          return res;
        },
        { ...pre },
      );
    });
    setTimeout(() => {
      onChange(uniq([...value, ...items.map(({ spuKey }) => spuKey)]));
    });
  };

  const onDeselect = (ids: string[]) => {
    setItemMap((pre) => {
      return ids.reduce((res, id) => {
        const { [id]: _, ...others } = res;
        return others;
      }, pre);
    });
    setTimeout(() => {
      onChange(value.filter((id) => !ids.includes(id)));
    });
  };

  return (
    <Container>
      <section>
        <Tabs activeKey={activeKey} onChange={setActiveKey}>
          <Tabs.TabPane key="list" tab={t('knowledge.item.select.mode.spu')} />
          <Tabs.TabPane key="batch" tab={t('knowledge.item.select.mode.mult')} />
        </Tabs>
        {activeKey === 'list' && (
          <ListSelect filter={filter} value={value} onSelect={onSelect} onDeselect={onDeselect} />
        )}
        {activeKey === 'batch' && <BatchSelect filter={filter} onSelect={onSelect} />}
      </section>
      <SelectResult itemMap={itemMap} value={value} onDeselect={onDeselect} />
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  align-items: stretch;
  height: 664px;
  > section {
    flex: 1 0 0;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    overflow: hidden;
    > div {
      flex: 1 0 0;
    }
    > .ant-tabs {
      flex: 0 0 auto;
      .ant-tabs-nav {
        margin-bottom: 0;
        padding: 0 24px;
      }
    }
  }
  > div {
    flex: 0 0 auto;
    width: 495px;
    background: var(--fett-erp-card-bg);
  }
`;

export default SelectContent;
